import { AnyBreakpoints, BreakpointAlias, BREAKPOINTS_ORDER } from 'application/theme'

/**
 * Из объекта, хранящего значения по брейкпоинтам, возвращает то значение,
 * которое применимо на переданом брейкпоинте (mobile-first)
 * @param stylesPerBreakpoint
 * @param breakpoint
 */
export const getValueForBreakpoint = <T = any>(
  stylesPerBreakpoint: AnyBreakpoints<T>,
  breakpoint: BreakpointAlias
): T => {
  const order: BreakpointAlias[] = [...BREAKPOINTS_ORDER].reverse()

  const possibleBreakpoints = order.slice(order.indexOf(breakpoint))

  const closestBreakpointName =
    possibleBreakpoints.find((breakpoint) => breakpoint in stylesPerBreakpoint) || possibleBreakpoints.slice(-1)[0]

  const StylesPerPhone = stylesPerBreakpoint['phone']
  const stylesPerClosestBreakpoint = stylesPerBreakpoint[closestBreakpointName]
  return stylesPerClosestBreakpoint === undefined ? StylesPerPhone : stylesPerClosestBreakpoint
}
